
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PFormInputTextSearch, PFormSelect } from "@/common/components";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { iniServicePointFilter, IServicePointFilter, SearchEntitiesRequest } from "@/services";
import { Country, Entity } from "@/entities";
import { Getter } from "vuex-class";

@Component({
  name: "user-detail-machines-header",
  components: {
    PFormInputTextSearch,
    PFormSelect,
    PIcon,
  },
})
export class CashTodayFilter extends Vue {
  @Prop({ required: true }) value!: IServicePointFilter;
  @Prop({ required: false, default: false }) needFirstLoad!: boolean;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.value) this.valueLocal = JSON.parse(JSON.stringify(this.value));
  }

  @Getter("getCountries") getCountries!: Country[];

  valueLocal: IServicePointFilter = { ...iniServicePointFilter };
  entities: Entity[] = [];
  isButtonDisabled = true;
  previousCountryCode = "";

  requestParams: SearchEntitiesRequest = {
    limit: 100,
    offset: 0,
    sortField: "aggregateId",
    sortWay: "DESC",
  };

  created(): void {
    if (this.needFirstLoad) {
      this.fetch();
    }
  }

  async fetch(): Promise<void> {
    const data = await this.$services.entity.fetchEntitiesV2(this.requestParams);
    this.entities = data.results;
  }

  validateTextFilter(): void {
    const previousCountryCode = this.previousCountryCode || "";
    const currentCountryCode = this.valueLocal.countryCode || "";
    const hasValidText = this.valueLocal.text && this.valueLocal.text.length >= 3;
    const hasCountryCode = !!this.valueLocal.countryCode;
    const hasEntityCode = !!this.valueLocal.entityCode;
    this.isButtonDisabled = !(hasValidText || hasCountryCode || hasEntityCode);
    if (previousCountryCode !== currentCountryCode) {
      this.requestParams.countryCode = currentCountryCode;
      this.fetch();
    }
    this.previousCountryCode = currentCountryCode;
  }

  search(): void {
    this.$emit("input", this.valueLocal);
  }
}
export default CashTodayFilter;
